import { render } from "./Unit_Transfer_Details.vue?vue&type=template&id=33ffe9f5&scoped=true"
import script from "./Unit_Transfer_Details.vue?vue&type=script&lang=js"
export * from "./Unit_Transfer_Details.vue?vue&type=script&lang=js"

import "./Unit_Transfer_Details.vue?vue&type=style&index=0&id=33ffe9f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ffe9f5"]])

export default __exports__